<template>
  <Page>
    <template #controls>
      <o-button class="page-settings-button is-hidden-tablet" aria-label="Table settings" @click="table?.openSettings()">
        <o-icon icon="cog" size="is-small" variant="secondary" />
      </o-button>
    </template>
    <Table ref="table" :display-settings-mobile="false" />
  </Page>
</template>

<script setup lang="ts">

  import Page from "@/components/Page.vue";
  import Table from "./Table.vue";
  import {ref} from "vue";

  const table = ref<InstanceType<typeof Table> | null>(null);

</script>

<style scoped>

</style>